import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css"

import Navbar from "./components/NavBar";

//routing pages
import Dashboard from "./pages/Dashboard";
// import Blog from "./pages/Blog";
import LoginForm from "./pages/Login.js";
import NotFound from "./pages/NotFound.js";
import Forside from "./pages/Forside.js"
import Kontakt from "./pages/Kontakt.js";
// Fællesskaber
import Boern from "./pages/faellesskaber/Boern.js";
import JuniorTeen from "./pages/faellesskaber/JuniorTeen.js";
import Unge from "./pages/faellesskaber/Unge.js"
import Kristendomskursus from "./pages/faellesskaber/Kristendomskursus.js";
import Andre from "./pages/faellesskaber/Andre.js";
import Alle from "./pages/faellesskaber/Alle.js";
// Gudstjenesten
import Gudstjeneste from "./pages/gudstjeneste/Gudstjenesten.js";
import Kirekligehandlinger from "./pages/gudstjeneste/Kirkeligehandlinger.js";
import Praedikener from "./pages/gudstjeneste/Praedikener.js";
//Om os
import HvemViEr from "./pages/omOs/HvemViEr.js"
import LedelseAnsatte from "./pages/omOs/LedelseOgAnsatte.js";
import DetViTrorPaa from "./pages/omOs/DetViTrorPaa.js";
//Blog
import Bloggen from "./pages/blog/bloggen.js";
import EditBlog from "./pages/blog/edit-blog.js";
// util
import ProtectedRoute from "./util/ProtectedRoute.js";
import Logout from "./util/Logout.js"


function App() {
  return (
    <div>
      <Router>
        <Navbar/>
        <Routes>
          <Route path="/login" element={<LoginForm/>} />
          <Route 
            path="/*"
            element={
              <ProtectedRoute>
                <Navbar /> {/* Navigation for switching pages */}
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/forside" element={<Forside />}/>
                    <Route path="/kontakt" element={<Kontakt />}/>

                    <Route path="/boern" element={<Boern />}/>
                    <Route path="/junior-teen" element={<JuniorTeen />}/>
                    <Route path="/unge" element={<Unge />}/>
                    <Route path="/kristendomskursus" element={<Kristendomskursus />}/>
                    <Route path="/andre" element={<Andre />}/>
                    <Route path="/alle" element={<Alle/>}/>
                    
                    <Route path="/gudstjeneste" element={<Gudstjeneste />}/>
                    <Route path="/kirkelige-handlinger" element={<Kirekligehandlinger />}/>
                    <Route path="/praedikener" element={<Praedikener />}/>
                    <Route path="/hvem-vi-er" element={<HvemViEr />}/>
                    <Route path="/ledelse-og-ansatte" element={<LedelseAnsatte />}/>
                    <Route path="/det-vi-tror-paa" element={<DetViTrorPaa />}/>
                    {/* bloggen */}
                    <Route path="/bloggen" element={<Bloggen/>}/>
                    <Route path="/edit-blog/:blogId" element={<EditBlog/>}/>
                    <Route path="*" element={<NotFound />} /> {/* 404 page */}
                  </Routes>
              </ProtectedRoute>
            }
          />
          
        </Routes>
      </Router>
    </div>
  );
}

export default App;